import { blockUi } from '@bndes/bndes-ux4/bndes-angular-utils';
import { FgiBackEndService } from '../../shared/fgi-back-end.service';
import { LimiteAdicionalTranch } from './../../model/limite-adicional-tranch.model';
import { Injectable } from "@angular/core";
import { catchError, Observable } from 'rxjs';
import { OpcaoFiltro } from 'src/app/model/opcao-filtro.model';
import { HttpParams } from '@angular/common/http';
import { ProgramaRepasseBndes } from '../../model/programas-permitidos.model';
import moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class LimiteAdicionalService extends FgiBackEndService<LimiteAdicionalTranch>{

  getNewEntity(): LimiteAdicionalTranch  {
          const model = new LimiteAdicionalTranch();
          return model;
      }

  protected getResourceURL(): string {
        return 'front/limite/adicional-tranch';
    }


  public salvarlimite(idTranche: number, limite: LimiteAdicionalTranch, programas: ProgramaRepasseBndes[]): Observable<any> {
    const options: any = blockUi();

    const params = new HttpParams()
    .set('nome',limite.nome)
    .set('dataInicioProtocolo', moment(limite.dataInicioProtocolo).format('YYYY-MM-DD'))
    .set('dataFimProtocolo', moment(limite.dataFimProtocolo).format('YYYY-MM-DD'))
    .set('permiteRenunciaLimiteAdicional', limite.permiteRenunciaLimiteAdicional);

    return this.http.post(`${this.BASE_URL}/salvar/${idTranche}`, programas, { ...options,params}).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public buscarTodosComFiltro(ideTranche: number, params?: any): Observable<Array<any>> {
    const options: any = blockUi();
    options.params = params;

    return this.http.get(
      `${this.BASE_URL}/filtros/tranche/${ideTranche}`,
      options
    ).pipe(
      catchError((e) => this.handleError(e))
    ) as Observable<Array<any>>;
  }


  public buscarAgentesFinanceirosPorTranche(
    ideTranche: number
  ): Observable<Array<OpcaoFiltro>> {

    const options = blockUi();

    return this.http.get(
      `${this.BASE_URL}/agentes-financeiros/tranche/${ideTranche}`,
      options
    ).pipe(
      catchError((e) => this.handleError(e))
    ) as Observable<Array<OpcaoFiltro>>;
  }


  public buscarLimitesAdicionaisPorTranche(
    ideTranche: number
  ): Observable<Array<OpcaoFiltro>> {

    const options = blockUi();

    return this.http.get(
      `${this.BASE_URL}/tipos/tranche/${ideTranche}`,
      options
    ).pipe(
      catchError((e) => this.handleError(e))
    ) as Observable<Array<OpcaoFiltro>>;
  }

    public editarLimite(idTranche: number, limite: LimiteAdicionalTranch, programas: ProgramaRepasseBndes[]): Observable<any> {
    const options: any = blockUi();

    const params = new HttpParams()
    .set('idLimite', limite.id)
    .set('dataInicioProtocolo', moment(limite.dataInicioProtocolo).format('YYYY-MM-DD'))
    .set('dataFimProtocolo', moment(limite.dataFimProtocolo).format('YYYY-MM-DD'))
    .set('permiteRenunciaLimiteAdicional', limite.permiteRenunciaLimiteAdicional);

    return this.http.post(`${this.BASE_URL}/editar/${idTranche}`, programas, { ...options,params}).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  
  public cadastrarLimitePorAf(dto: any): Observable<any> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/limite-af/cadastrar`, dto, options).pipe(
      (catchError((e) => this.handleError(e)))) as Observable<any>;
  }


  public editarLimitePorAf(dto: any): Observable<any> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/limite-af/editar`, dto, options).pipe(
      (catchError((e) => this.handleError(e)))) as Observable<any>;
  }

  public buscarLimitesAdicionaisPorModalidade(): Observable<Array<any>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/limites`, options).pipe(
      catchError((e) => this.handleError(e))
    ) as Observable<Array<any>>;
  }


}
